import { render, staticRenderFns } from "./BitacoraAgenciamiento.vue?vue&type=template&id=0df0c484&scoped=true"
import script from "./BitacoraAgenciamiento.vue?vue&type=script&lang=js"
export * from "./BitacoraAgenciamiento.vue?vue&type=script&lang=js"
import style0 from "./BitacoraAgenciamiento.vue?vue&type=style&index=0&id=0df0c484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0c484",
  null
  
)

export default component.exports